export const API_KEY = "0bb855cf7f88fb3ee171b7c1957c045f";
export const TMBD_BASE_URL = "https://api.themoviedb.org/3";
